import { ReactFlowProvider } from 'react-flow-renderer';

import OwnershipGraphReactFlow from 'src/modules/3rd-party-management/components/ownership-graph';

const StructureComparisonColumn = ({
    header,
    graphData,
    isLoading,
    emptyMessage = null,
    graphHeight = 600,
}) => {
    if (isLoading) {
        return (
            <div className="overview-corporate-structure-comparison__column">
                <div className="dt-field dt-skeleton mb-3" style={{ width: '70%', height: '24px' }} />
                <div className="dt-field dt-skeleton" style={{ width: '100%', height: `${graphHeight}px` }} />
            </div>
        );
    }

    return (
        <div className="overview-corporate-structure-comparison__column">
            {header && (
                <h6 className="overview-corporate-structure-comparison__column-header mb-3">
                    {header}
                </h6>
            )}

            {graphData && (
                <div className="overview-corporate-structure-comparison__graph">
                    <ReactFlowProvider>
                        <OwnershipGraphReactFlow
                            data={graphData}
                            height={graphHeight}
                        />
                    </ReactFlowProvider>
                </div>
            )}

            {!graphData && emptyMessage && (
                <div
                    className="overview-corporate-structure-comparison__empty"
                    style={{ minHeight: `${graphHeight}px` }}
                >
                    {emptyMessage}
                </div>
            )}
        </div>
    );
};

export default StructureComparisonColumn;
